var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcMsp40(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9684_46039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "#101233"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6001 14.3999H22.4001V19.1999H17.6001V22.3999H22.4001V30.3999H25.6001V22.3999H30.4001V19.1999H25.6001V14.3999Z",
    fill: "#03F5AE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4893 11.04C17.6547 9.10276 20.7264 8 24 8C27.2736 8 30.3453 9.10276 32.5107 11.04H34.2753C35.2427 11.04 36.1703 11.4522 36.8188 12.1696C37.4673 12.887 37.7822 13.8511 37.6825 14.8133L35.4734 36.1199H38.842C38.9933 36.1178 39.1435 36.1457 39.2839 36.202C39.4243 36.2583 39.5521 36.342 39.6598 36.448C39.7676 36.5541 39.8531 36.6805 39.9115 36.8199C39.9699 36.9592 40 37.1088 40 37.2599C40 37.411 39.9699 37.5605 39.9115 37.6999C39.8531 37.8393 39.7676 37.9657 39.6598 38.0718C39.5521 38.1778 39.4243 38.2615 39.2839 38.3178C39.1435 38.3741 38.9933 38.402 38.842 38.3999H9.15796C9.00667 38.402 8.85646 38.3741 8.71607 38.3178C8.57568 38.2615 8.4479 38.1778 8.34016 38.0718C8.23242 37.9657 8.14686 37.8393 8.08847 37.6999C8.03007 37.5605 8 37.411 8 37.2599C8 37.1088 8.03007 36.9592 8.08847 36.8199C8.14686 36.6805 8.23242 36.5541 8.34016 36.448C8.4479 36.342 8.57568 36.2583 8.71607 36.202C8.85646 36.1457 9.00667 36.1178 9.15796 36.1199H12.5251L10.3175 14.8118C10.2185 13.8496 10.532 12.887 11.1797 12.1696C11.8305 11.4506 12.7573 11.04 13.7247 11.04H15.4893ZM20.8 12.8H27.2V17.6H32V24H27.2V32H20.8V24H16V17.6H20.8V12.8Z",
    fill: "#CAFFCA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9684_46039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMsp40);
export default __webpack_public_path__ + "static/media/ic_msp-40.e78e4933f90eccd8a3c46dff03510f49.svg";
export { ForwardRef as ReactComponent };